var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");

var SnapLineType = require("./snapLineType.js");
var SnapSet = require("./snapSet.js");

var SnapModel = function (editorModel, cameraModel, originModel, selectionModel, rules) {
    lib_core.Model.apply(this, arguments);

    this.editorModel = editorModel;
    this.cameraModel = cameraModel;
    this.originModel = originModel;
    this.selectionModel = selectionModel;

    this.rules = rules;
    this.snap_info = this.value('snap_info', false);

    this.last_snap_vec = new lib_geometry.Coord(0,0);
    this.snapFrom = null;

    this.onInit("initialize", this.initialize);
};
lib_core.inherit(SnapModel, lib_core.Model);
lib_core.JsonParser.registerClass(SnapModel, "SnapModel");
module.exports = SnapModel;

SnapModel.prototype.initialize = function () {
    var self = this;

    console.assert(this.parent().getSnappedMouseDisplacement, "getSnappedMouseDisplacement function not found in parent model. Maybe this extension was not placed correctly?");
    this.parent().getSnappedMouseDisplacement = function (snapCollection, ignoreCollection) {
        var vec = self.editorModel.mouseDisplacement();

        var last_snap_vec = self.last_snap_vec;
        return self.getSnappedVec(vec, snapCollection, ignoreCollection, true).sub(last_snap_vec); // to be used in a loop for differential calculations
    };

    this.parent().getSnapVec = function (collection, handle) {
        var ignoreCollection = new lib_core.Collections.HashSet();
        ignoreCollection.addAll(collection);
        ignoreCollection.remove(handle);
        return self.getSnappedVec(new lib_geometry.Coord(0, 0), [handle], ignoreCollection);
    };

    console.assert(this.parent().getSnappedMousePos, "getSnappedMousePos function not found in parent model. Maybe this extension was not placed correctly?");
    this.parent().getSnappedMousePos = function (filter, parent) {
        var pos = self.editorModel.mousePos();
        return self.getSnapPoint(pos, filter, parent);
    };

    console.assert(this.parent().clearSnap, "clearSnap function not found in parent model. Maybe this extension was not placed correctly?");
    this.parent().clearSnap = function () {
        self.clear();
    };

    this.setupSpatialIndex();
};

SnapModel.prototype.setupSpatialIndex = function () {
    var self = this;

    this.toSnapContainers = new lib_core.ObservableSet();
    this.snapContainerIMMap = new lib_core.Collections.HashMap();
    this.imSnapContainersMap = new lib_core.Collections.Bins();
    var invalidated = new lib_core.Collections.HashSet();

    var removeElement = function (im, removeHandlers) {
        var containers = self.imSnapContainersMap.get(im);
        self.toSnapContainers.removeAll(containers);
        self.snapContainerIMMap.removeAll(containers);
        containers.removeAll();
        if(removeHandlers) {
            if(im.snapSetTo) im.snapSetTo.removeHandlers(self);
            else if(im.data) im.data.removeHandlers(self);
        }
        invalidated.remove(im);
    };

    var addElement = function (im) {
        if(im.snapSetTo) {
            im.snapSetTo.onChange(self, function () {
                removeElement(im, false);
                invalidated.add(im);
            });
        } else if (im.data) {
            im.data.onBubble(self, function () {
                removeElement(im, false);
                invalidated.add(im);
            });
        }
        invalidated.add(im);
    };

    var updateElement = function (im) {
        var containers = self.imSnapContainersMap.get(im);
        self.toSnapContainers.removeAll(containers);
        self.snapContainerIMMap.removeAll(containers);
        containers.removeAll();

        var snapset = im.getSnapSet(SnapLineType.TO);
        snapset._content.forEach(function(container){
            self.toSnapContainers.add(container);
            self.snapContainerIMMap.put(container, im);
            self.imSnapContainersMap.put(im, container);
        });
    };

    this.editorModel.interactionModelDataMap.forEach(function (data, im) {
        if(im.getSnapSet) addElement(im);
    });
    this.editorModel.interactionModelDataMap.onPut(this, function (data, im) {
        if(im.getSnapSet) addElement(im);
    });
    this.editorModel.interactionModelDataMap.onRemove(this, function (data, im) {
        if(im.getSnapSet) removeElement(im, true);
    });

    if (this.originModel) {
        addElement(this.originModel);
        this.cameraModel.workplane.onChange(this, function () { invalidated.add(self.originModel); }, 10);
        this.originModel.onBubble(this, function () { invalidated.add(self.originModel); }, 10);
    }

    this.toSpatialIndex = new lib_core.SpatialIndex(
        "strtree",
        this.toSnapContainers,
        function (snapContainer) {
            var range = snapContainer.range;
            return snapContainer.obj.getBB().buffer(range);
        },
        null,
        null,
        function () {
            var updated = new lib_core.Collections.HashSet();
            self.selectionModel.selection.forEach(function (im) { // TODO
                if(im.getSnapSet) removeElement(im, false);
            });
            invalidated.forEach(function (im) {
                if(!self.selectionModel.selection.contains(im)) {
                    updateElement(im);
                    updated.add(im);
                }
            });
            invalidated.removeAll(updated);
        }
    );
};

SnapModel.prototype.clear = function() {
    this.snap_info(null);
    this.last_snap_vec = new lib_geometry.Coord(0, 0);
    this.snapFrom = null;
};

SnapModel.prototype.getSnapSet = function(snappables, type) {
    var snapset = new SnapSet();
    snappables.forEach(function(snappable){
        try {
            if(snappable.getSnapSet) {
                snapset.addAll(snappable.getSnapSet(type));
            }
        }
        catch (e) { logError("selectable.getSnapSet", e, logError.criticality.TRIVIAL); }
    });
    return snapset;
};

SnapModel.prototype.getSnappedVec = function (vec, snapCollection, ignoreCollection, useCache) {
    if (!this.snapFrom || !useCache) {
        var snapFromCollection = new lib_core.Collections.HashSet();
        snapFromCollection.addAll(snapCollection);
        this.snapFrom = this.getSnapSet(snapFromCollection, SnapLineType.FROM);
    }

    this.snapFrom.move(vec);

    var snap_info =  this.snapFrom.trySnapTo(4 / this.cameraModel.viewS(), this, this.editorModel);

    if (snap_info) {
        this.snap_info( snap_info );
        this.last_snap_vec = snap_info.vec;
    } else {
        this.snap_info( null );
        this.last_snap_vec = new lib_geometry.Coord(0,0);
    }

    return snap_info ? vec.add(snap_info.vec) : vec;
};

SnapModel.prototype.getSnapPoint = function (pos, filter, parent) {
    var snapFrom = new SnapSet();
    snapFrom.add(pos, 1, 0, null, parent, 0, null, null);

    var snap_info = snapFrom.trySnapTo(4 / this.cameraModel.viewS(), this, this.editorModel);
    if (snap_info) {
        this.snap_info(snap_info);
        return pos.add(snap_info.vec);
    } else {
        this.snap_info(null);
        return pos;
    }
};

SnapModel.prototype.getRule = function(from, to) {
    var self = this;

    if(!this.rules) return;

    // supposition 1: snapSets have a parent, which is a model or interactionModel
    var fromModel   = from.parent;
    var toModel     = to.parent;
    if(!fromModel || !toModel) return;

    // supposition 2: if the model has no data, use the model class (e.g. origin)
    var fromObj = fromModel.data   ? fromModel.data : fromModel;
    var toObj   = toModel.data     ? toModel.data   : toModel;

    var checkColMatch = function (ruleCol, obj) {
        if(!ruleCol) return true;
        var colMatch = false;
        var path = self.root.jsonifyPath(obj.getPath());
        var end = path.length-1;
        var stringPath = (path.slice(0,end)).join("/");
        var regex = new RegExp(ruleCol.map(function(rule) { return (new RegExp(rule)).source; }).join("/"));
        return regex.test(stringPath);
    };

    var filteredRules = this.rules.filter(function(rule) {
        var fromClassMatch = false;
        var fromTypes = rule.fromClass instanceof Array ? rule.fromClass : [rule.fromClass];
        fromTypes.forEach(function(type) {
            fromClassMatch = fromClassMatch || (fromObj instanceof type);
        });
        if (!fromClassMatch) return false;

        var toClassMatch = false;
        var toTypes = rule.toClass instanceof Array ? rule.toClass : [rule.toClass];
        toTypes.forEach(function(type) {
            toClassMatch = toClassMatch || (toObj instanceof type);
        });
        if (!toClassMatch) return false;

        if (!checkColMatch(rule.fromPath, fromObj)) return false;

        if (!checkColMatch(rule.toPath, toObj)) return false;

        var fromKeyRegex = new RegExp(rule.fromKey);
        var fromKeyMatch = from.key ? fromKeyRegex.test(from.key)
                                    : true;
        if (!fromKeyMatch) return false;

        var toKeyRegex = new RegExp(rule.toKey);
        var toKeyMatch = to.key ? toKeyRegex.test(to.key)
                                : true;
        if (!toKeyMatch) return false;

        return true;
    });

    var filters = [];
    filteredRules.forEach(function(rule) {
        var filter = rule.condition instanceof Function ? rule.condition : function () { return rule.condition; };
        filters.push(filter);
    });

    if(filters.length) {
        return function () {
            var pass = true;
            filters.forEach(function (filter) {
                pass = pass && filter.call(self, from, to);
            });
            return pass;
        };
    }
};
